import React from "react";
import {useRouter} from "next/navigation";

import {cn} from "@isudio/utils";

import {Card, CardContent, CardHeader, CardTitle} from "../../";

export interface ICaseCard {
  link: string;
  title: string;
  image: string;
  text: string;
}

interface CaseCardProps {
  className?: string;
  workCase: ICaseCard;
}

const CaseCard = React.forwardRef<Element, CaseCardProps>(
  ({
     className = "case-card",
     workCase
   }: CaseCardProps
  ) => {
    const router = useRouter();

    return (
      <Card
        className={cn(className,
          `flex flex-col w-full h-fit gap-4 p-4 cursor-pointer`,
          `rounded-tl-3xl rounded-tr-none rounded-bl-none rounded-br-3xl border-none shadow-[1px_1px_2px_1px_rgba(125,125,125,1)]`,
          `bg-linear-to-bl from-custom-gray-150 dark:from-custom-gray-300 from-1% via-custom-gray-200 dark:via-custom-gray-400 via-25% to-custom-gray-175 dark:to-custom-gray-500 to-100%`,
        )}
        onClick={() => {router.push(workCase.link)}}
      >
        <CardHeader
          className="relative flex flex-col items-start justify-start rounded-[10px] overflow-hidden">
          <div className="w-full flex items-center justify-center">
            <img
              src={workCase.image}
              alt={workCase.title}
              className="w-full h-auto object-contain"
            />
          </div>
          <CardTitle
            className="absolute bottom-0 w-full p-2 bg-[#00000080]">
              <span
                className={`
                text-md font-normal tracking-tight leading-[1.2] line-clamp-1 text-white 
                text-shadow-[0.5px_0.5px_1px_rgba(21,21,21,1) dark:text-shadow-[1px_2px_1px_rgba(0,0,0,1)]`}
              >
                {workCase.title}
              </span>
          </CardTitle>
        </CardHeader>

        <CardContent
          className="flex-1">
          <div className={`w-full text-custom-gray-600 dark:text-pale-white text-[0.85rem] italic tracking-tight leading-[1.3] line-clamp-5`}>
            {workCase.text}
          </div>
        </CardContent>
      </Card>
    )
  }
);

CaseCard.displayName = "CaseCard";
export {CaseCard};